import type { FC } from "react";
import React from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import { SecondaryBoxTitle } from "pro-features/styled components/StyledBoxTitle/src/StyledBoxTitle";
import { PieChart } from "app/pages/website-analysis/traffic-sources/display-ads/common/PieChart";
import { availableDataTypes } from "app/pages/website-analysis/traffic-sources/display-ads/common/DisplayAdsTypes";
import { StyledBox, TitleWrapper } from "app/pages/website-analysis/analyze-publishers/advertisers/common/StyledComponents";
import type { IFilterItem } from "app/pages/website-analysis/analyze-publishers/advertisers/common/types";
import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";

const AdvertisersTopNetworksDistributionInner: FC<{
    networks: IFilterItem[];
}> = ({ networks }) => {
    const i18n = i18nFilter();
    const title = i18n("analysis.publishers.advertisers.top.networks.distribution.title");
    const tooltip = i18n("analysis.publishers.advertisers.top.networks.distribution.info");

    const transformData = (data) => {
        const tmpDataArr = data.length > 4 ? data.slice(0, 4) : data;
        const totalValues = tmpDataArr.reduce((total, item) => {
            total += item.Value;
            return total;
        }, 0);
        const returnedArray =
            totalValues < 1 ? [...tmpDataArr, { Name: "Others", Value: 1 - totalValues }] : [...tmpDataArr];

        return returnedArray.map((item) => {
            const { Name, Value } = item;
            return {
                y: Value,
                percent: Value,
                name: Name,
            };
        });
    };

    const getComponent = () => {
        const tooltipHeaders = [
            i18n("analysis.source.ad.websites.table.columns.category.title"),
            i18n("wa.ao.graph.trafficshare"),
        ];
        const pieChartConfig = {
            chartType: availableDataTypes[1],
            tooltipHeaders,
            tooltipContainerWidth: 280,
            isEmptyStateSmall: true,
        };
        return networks && networks.length > 0 ? (
            <PieChart
                pieChartData={transformData(networks)}
                pieChartConfig={pieChartConfig}
            />
        ) : (
            <NoDataLandscape
                title="analysis.publishers.advertisers.empty.state.title"
                subtitle=""
            />
        );
    };

    return (
        <StyledBox>
            <TitleWrapper>
                <SecondaryBoxTitle tooltip={tooltip}>{title}</SecondaryBoxTitle>
            </TitleWrapper>
            {getComponent()}
        </StyledBox>
    );
};

const propsAreEqual = (prevProps, nextProps) => {
    const { networks } = prevProps;
    const { networks: nextData } = nextProps;
    return networks === nextData;
};

export const AdvertisersTopNetworksDistribution = React.memo(AdvertisersTopNetworksDistributionInner, propsAreEqual);
